export { default as Img200 } from './processed/200/The-Stuarts-A-Bloody-Reign.jpg';
export { default as Img400 } from './processed/400/The-Stuarts-A-Bloody-Reign.jpg';
export { default as Imgthumb } from './processed/thumb/The-Stuarts-A-Bloody-Reign.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/The-Stuarts-A-Bloody-Reign.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/The-Stuarts-A-Bloody-Reign.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      205,
      142,
      89
    ],
    "_population": 2178,
    "_hsl": [
      0.07614942528735633,
      0.5370370370370371,
      0.5764705882352941
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      98,
      51,
      28
    ],
    "_population": 2311,
    "_hsl": [
      0.05476190476190476,
      0.5555555555555556,
      0.24705882352941178
    ]
  },
  "Muted": {
    "_rgb": [
      150,
      124,
      84
    ],
    "_population": 1861,
    "_hsl": [
      0.101010101010101,
      0.28205128205128205,
      0.45882352941176474
    ]
  },
  "LightMuted": {
    "_rgb": [
      160,
      168,
      172
    ],
    "_population": 2,
    "_hsl": [
      0.5555555555555557,
      0.06741573033707873,
      0.6509803921568628
    ]
  },
  "DarkMuted": {
    "_rgb": [
      96,
      74,
      50
    ],
    "_population": 2163,
    "_hsl": [
      0.08695652173913047,
      0.31506849315068497,
      0.28627450980392155
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/The-Stuarts-A-Bloody-Reign.js